module.exports = __webpack_public_path__ + "media/images/pic/kids-e3f70016165d50c35e31432f5f8c72df.webp";